export const isLoggedIn = (state) => !!state.token;
